import React from "react";
import PropTypes from "prop-types";
import Result from "./Result";
import Box from "@mui/material/Box";

// Loader component
import { DisappearedLoading } from "react-loadingg";

function SearchBodyContent({ results, initialLoader, selectedFrn, onSelect }) {
  return (
    <Box sx={{ mt: 1 }}>
      {initialLoader && (
        <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
          <DisappearedLoading color="#9a0606" />
        </Box>
      )}
      {!initialLoader && (
        <Box id="body-cards">
          {results.map((result, i) => (
            <Result
              key={result.frn?.raw ?? i}
              result={result}
              selected={selectedFrn != null && result.frn?.raw === selectedFrn}
              onSelect={onSelect}
            />
          ))}
        </Box>
      )}
    </Box>
  );
}

export default SearchBodyContent;

SearchBodyContent.propTypes = {
  results: PropTypes.array,
  initialLoader: PropTypes.bool,
  selectedFrn: PropTypes.any,
  onSelect: PropTypes.func,
};
